var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49836 7.29861L13.7686 1.60619C14.0099 1.38623 14.0668 1.09961 13.9189 0.836316C13.8198 0.660789 13.6491 0.541919 13.4499 0.511924C13.228 0.476374 12.9969 0.550806 12.8148 0.715224C11.5287 1.8817 10.2425 3.04818 8.95751 4.21688L8.78451 4.37352C8.19038 4.91232 7.59624 5.45113 6.99984 5.99659C6.86098 5.86995 6.72212 5.74441 6.58326 5.61888L1.91101 1.3729C1.65037 1.13627 1.392 0.898528 1.12453 0.669676C0.844534 0.426382 0.4143 0.44749 0.167314 0.715224C0.0546331 0.835205 0 0.977404 0 1.12071C0 1.29624 0.0808105 1.47399 0.241295 1.61952L6.4831 7.28305C6.58668 7.37748 6.75285 7.50413 6.99642 7.49968C7.17625 7.50524 7.34471 7.43747 7.49836 7.29861Z",
    fill: "#2D2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.e0a98028015bb91934d93cc6de96be0c.svg";
export { ForwardRef as ReactComponent };